// extracted by mini-css-extract-plugin
export default {"title":"e7TMh8"};